import { API_ERROR_MARKET_NOT_FOUND } from 'config/constants';

export const ERROR_USER_EXISTS = 'USER_EXISTS';

export type ExposedErrorCodes =
  | typeof API_ERROR_MARKET_NOT_FOUND
  | typeof ERROR_USER_EXISTS
  // the user resets their password on all other clients, or one year after created
  | 'SESSION_TIMEOUT'
  // incorrecty login
  | 'INVALID_CREDENTIALS'
  // session missing or other way incorrect
  | 'REQUIRED_API_KEY'
  // when user tries to login but verification is needed
  | 'EMAIL_VERIFICATION_REQUIRED'
  // Nonce timing issue - user system clocks being far out of sync with server time.
  | 'INVALID_NONCE_TIMING'
  // Vault 404
  | 'MANAGED_ACCOUNT_NOT_FOUND'
  // Delegated key was revoked or expired server-side
  | 'DELEGATED_KEY_INVALID';

/**
 * Determine whenever response error signalize that user is logged out
 */
export const isUserLoggedOutError = (error: KatanaApiError) => {
  return (
    error?.idexErrorCode === 'SESSION_TIMEOUT' ||
    error?.idexErrorCode === 'INVALID_CREDENTIALS' ||
    error?.idexErrorCode === 'REQUIRED_API_KEY'
  );
};

export class KatanaApiError extends Error {
  public idexErrorCode?: ExposedErrorCodes;

  constructor(message: string, code?: ExposedErrorCodes) {
    super(message);
    this.idexErrorCode = code;
  }
}
